<template lang='pug'>
  span {{capitalized}}
</template>

<script>
import {capitalize} from 'lodash';

export default {
  name: 'Capitalize',
  props: {
    value: {
      type: String
    }
  },
  computed: {
    capitalized() {
      return capitalize(this.value);
    }
  }
};
</script>

<style scoped>

</style>
